import React, { FC } from 'react';
import SectionMessage from '@atlaskit/section-message';

import ExternalLinkAction from '@/components/primitive/external-link';
import { DAC_TROUBLESHOOTING_DOC_LINK } from '@/constants';

/**
 * SFx fill(0) warning
 * @see https://hello.atlassian.net/browse/TOME-1138
 */
const QueryUnfilledWarning: FC = () => (
  <SectionMessage appearance="warning">
    Adding a <b>fill(0)</b> after your aggregation functions in SignalFlow query may resolve the
    problem.
    <p>
      <ExternalLinkAction
        text="Find out the details on our doc"
        href={`${DAC_TROUBLESHOOTING_DOC_LINK}#data-point-timestamps-for-good-and-bad-events-did-not-align`}
      />
    </p>
  </SectionMessage>
);

export default QueryUnfilledWarning;
